
import { Vue, Component, Watch } from 'vue-property-decorator'
import { searchApplicationOrInformation, ApplicationDto, InformationListDto } from '@/api/homes'
import { Getter } from 'vuex-class'
import { InformationListDTO } from '@/api/information'
import { getUserOtherInfoFCD } from '@/api/commonConfig'
import JumpWarn from '@/views/financial/JumpWarn.vue'

@Component({
    name:'SearchHomes',
    components: {
        JumpWarn
    }
})
export default class SearchHomes extends Vue {
    @Getter userId!: string
    @Getter info: any // 公司头像
    translationsApp: ApplicationDto[] = []
    news: InformationListDto[] = []

    banners = [
        {
            url: 'agree-bg.png'
        },
        {
            url: 'agree-bg.png'
        },
        {
            url: 'agree-bg.png'
        }
    ]
    // 关键字
    searchVal = ''
    // 新数据
    searchData = []

    loading = false
    finished = false

    // 查询参数
    params = {
        search: '',
        scope: '1', // APP传1 PC传2
        partnerCompanyId: 'system',
        type: '0', // 传0 是查询全部  1:只查应用  2:只查资讯
        pageIndex: 1,
        pageSize: 10
    }

    created () {
        this.params.partnerCompanyId = this.info.partnerCompanyId || 'system'
    }

    // 关键字高亮
    get newData () {
        return this.news
            .map((item) => {
                if (item.title.includes(this.params.search)) {
                    // let titleObj = document.getElementsByClassName('title')
                    item.hightTitle = item.title.replace(
                        this.params.search,
                        `<span style='color:red;'>${this.params.search}</span>`
                    )
                    return item
                }
            })
            .filter(Boolean)
    }

    // 重置数据
    @Watch('news', {immediate: true})
    handleSearchVal () {
        this.searchData = JSON.parse(JSON.stringify(this.news))
    }

    /**
     * @description: 搜索事件
     * @param {*} val
     * @return {*}
     */
    onSearch (val) {
        this.params.search = val
        this.params.pageIndex = 1
        this.finished = false
        this.news = []
        this.onLoad()
    }

    onLoad () {
        this.loading = true
        if (this.params.pageIndex !== 1) {
            this.params.type = '2'
        }
        if (this.$checkIsEmpty(this.params.search)) {
            this.$toast('请输入搜索关键字')
            return false
        }
        searchApplicationOrInformation(this.params).then(res => {
            if (this.params.type === '0') {
                this.translationsApp = res.data.allList
                this.translationsApp.map(item => {
                    item = this._handleAction(item)
                })
            }
            this.news = this.news.concat(res.data.informationList.records)
            this.params.pageIndex++
            if (this.news.length >= res.data.informationList.totalRecords) {
                this.finished = true
            }
        }).finally(() => {
            this.loading = false
        })
    }

    /**
     *  应用数据绑定权限
     */
    _handleAction (app: ApplicationDto) {
        app.action = app.route.substring(1, app.route.length)
        return app
    }

    /**
     * 跳转应用
     */
    goApp (app: ApplicationDto) {
        if (!this.$isAction(app.action)) {
            this.$toast('暂无此操作权限，请联系管理员')
            return false
        }
        if (app.route === '/financialServices') {
            this._getInfoFCD()
            return false
        }
        if (app.route === '/valetOrder') {
          this.$router.push({ path:app.route,query:{fromPath:'3'}})
          return false
        }
        this.$router.push(app.route)
    }

    /**
     * 判断用户金融服务授信是否已过期
     */
    _getInfoFCD () {
        getUserOtherInfoFCD({userId: this.userId}).then((res) => {
            if (res.code === '000000' && res.data.isExpire !== true) {
                //    跳转到金融服务页面
                this.$router.push({
                    path: '/financialServices',
                })
            } else {
                // 进入授信流程
                (this.$refs.jumpWarn as any).showModal()
            }
        })
    }

    handleInformation (inform: InformationListDTO) {
        this.$router.push({
            name: 'InformationDetail',
            query: {
                informationId: inform.informationId,
                publishTime: inform.publishTime,
                companyName: inform.companyShortName,
                title: inform.title,
                visitsNumber: inform.visitsNumber + ''
            }
        })
    }
}
